module.exports = __webpack_public_path__ + "static/media/playBtn.92f35f98.png";